import React, { useState, ChangeEvent, useEffect } from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';

import Divider from '@bharatpe/bharat-ui/web/Divider';
import FormControl from '@bharatpe/bharat-ui/web/FormControl';
import PaymentOption from '../PaymentOption';
import { PaymentOptionsListProps } from './PostpePaymentOptionsList.types';

const useStyles = makeStyles({
	root: {
		padding: '4px!important',

		'& .MuiFormGroup-root': {
			overflow: 'hidden',
		},
	},
});

const PostpePaymentOptionsList: React.FC<PaymentOptionsListProps> = ({ onSelected, list, isShowUnityUi }) => {
	const classes = useStyles();
	const [selectedOption, setSelectedOption] = useState<any>({});
	const [paymentOptions, setPaymentOptions] = useState<any>([]);

	const handleModeChange = (value: any) => {
		if (selectedOption !== value) {
			setSelectedOption(value);
			const id = value && value.split('-')[2];
			onSelected(list[id], id);
		}
	};

	const onPaymentOptionSelected = (value: any) => {
		if (selectedOption !== value) {
			handleModeChange(value);
		}
	};

	useEffect(() => {
		setPaymentOptions(list);
	}, []);

	useEffect(() => {
		paymentOptions.forEach((item: any, idx: any) => (item.selected ? setSelectedOption(`pg-option-${idx}`) : ''));
	}, [paymentOptions]);

	return (
		<ul className={clsx(`list-style-none flex flex-column light-background default-border-radius`, classes.root)}>
			<FormControl component="fieldset">
				<RadioGroup
					aria-label="payment-Options"
					name="payment-options"
					value={selectedOption as any}
					className="radio"
					onChange={(e: ChangeEvent<HTMLInputElement>) => {
						handleModeChange(e.target.value);
					}}>
					{paymentOptions?.map((item: any, index: any) => (
						<>
							<PaymentOption
								isShowUnityUi={isShowUnityUi}
								{...item}
								id={`pg-option-${index}`}
								onPaymentOptionSelected={onPaymentOptionSelected}
							/>
							{index < list?.length - 1 ? <Divider /> : null}
						</>
					))}
				</RadioGroup>
			</FormControl>
		</ul>
	);
};

export default PostpePaymentOptionsList;
